import Vue from 'vue';
import VueQRCodeComponent from 'vue-qrcode-component';
Vue.component('QrCode', VueQRCodeComponent);
